import { render } from "./BuildingSnapshot.vue?vue&type=template&id=22301104"
import script from "./BuildingSnapshot.vue?vue&type=script&lang=js"
export * from "./BuildingSnapshot.vue?vue&type=script&lang=js"

import "./BuildingSnapshot.vue?vue&type=style&index=0&id=22301104&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__